import { ReactNode } from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

export const InsightSummary: React.FC<{ children: ReactNode; title: string }> = ({
  children,
  title,
}) => {
  return (
    <Box gap="s16" padding="s12">
      <Box flexDirection="row" gap="s4" alignItems="center">
        <Icon.Small icon="ai" color="grey800" />
        <Text weight="semibold" size="300">
          {title}
        </Text>
      </Box>
      {children}
    </Box>
  )
}
